import { NavigationEntry } from './interfaces';
import { getTeaserEntries } from './ressort';


export function getNavigationEntry(entry: any) : NavigationEntry | null {
  if(entry && entry.id && entry.name) {

    let entries: NavigationEntry[] = []
    if(entry.entries && entry.entries.length > 0) {
      entries = entry.entries.map((e) => {
       return getNavigationEntry(e)
      })
    }
    entries = entries?.filter(e => e?.id)

    let navigationEntry: NavigationEntry = {
      id: entry.id,
      linkedId: entry.linkedId || null,
      title: entry.name,
      extendable: entry.extendable === true,
      loading: false,
      links: entry.links ?? [],
      children: entries,
      trendingTopics: getTeaserEntries({ teasers: entry.trendingTopics }),
      status: 200
    }

    return navigationEntry
  }
  return null
}